import { memo } from "react";

import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { Dropdown } from "@/components/sidebar/Dropdown";

import type { DropdownItem } from "@/components/sidebar/Dropdown";

export const LockIndicatorMenu = memo(function LockIndicatorMenu({
  items,
  onOpenChange,
}: {
  items: DropdownItem[];
  onOpenChange?: (open: boolean) => void;
}) {
  const t = useTranslations();

  return (
    <Dropdown
      anchor="bottom start"
      onOpenChange={onOpenChange}
      className="absolute z-10 top-1/2 -translate-y-1/2 right-0 mr-1 group-has-[:focus-visible]:hidden"
      toggleButtonLabel={t("documentTree.lockedMenuLabel")}
      // Opens the same items as the row's Actions menu, so keyboard users reach those instead
      toggleButtonProps={{ tabIndex: -1 }}
      toggleButtonComponent={
        <Sidebar.Button
          as="div"
          className="!rounded-4 !min-h-0 !min-w-0 w-6 h-6 my-auto hover:bg-blue-100 hover:dark:bg-blue-900"
          icon={<Icon name="LockLocked" className="w-[20px] h-[20px]" />}
          inverted
        />
      }
      items={items}
      itemsClassName="fromSm:-translate-x-1/2 fromSm:ml-3 sm:-translate-x-7"
    />
  );
});
